import AbstractApi from '@/api/abstracts/AbstractApi'
import httpClient from '@/utilities/service/httpClient'
// Types
import { ProjectPurchaseNumberPayload } from '@/api/types/request/ProjectPurchaseNumberPayload'
import { ProjectPurchaseNumberType } from '@/api/types/response/ProjectPurchaseNumberType'
import ProjectInvoiceApi from '@/api/services/sales/project/overview/invoice/ProjectInvoiceApi'
import ProjectAccrualApi from '@/api/services/sales/project/overview/accrual/ProjectAccrualApi'
import ProjectDeferralApi from '@/api/services/sales/project/overview/deferral/ProjectDeferralApi'
import ProjectFeeApi from '@/api/services/sales/project/overview/fee/ProjectFeeApi'

/**
 * @property string apiEnd /api/sales/project/overview/{BidNumber}
 */
export default class ProjectOverviewApi extends AbstractApi {
  purchaseNumber(payload: ProjectPurchaseNumberPayload): Promise<ProjectPurchaseNumberType> {
    return httpClient.post(`${this.apiEnd}/po-number`, payload)
  }

  invoice(): ProjectInvoiceApi {
    return new ProjectInvoiceApi(`${this.apiEnd}/invoice`)
  }

  accrual(): ProjectAccrualApi {
    return new ProjectAccrualApi(`${this.apiEnd}/accrual`)
  }

  deferral(): ProjectDeferralApi {
    return new ProjectDeferralApi(`${this.apiEnd}/deferral`)
  }

  feeAdjustment(): ProjectFeeApi {
    return new ProjectFeeApi(`${this.apiEnd}/adjustment`)
  }
}
